/**
 * z__jsCartPromo.js.liquid
 * Manual Free Gift promo (no Kite)
 *
 * Exposes:
 *   window.zCartPromo.init()
 *   window.zCartPromo.refresh()
 *   window.zCartPromo.claim()
 *
 * Notes:
 * - You cannot add "tags" to cart items; uses line item properties instead.
 * - Making item $0 requires pricing/discount logic (Shopify cannot set $0 via cart API).
 */

window.zCartPromo = window.zCartPromo || {};

(function () {
  'use strict';

  let __bound = false;
  let __claiming = false;

  var SEL = {
    mount: '[data-free-gift-mount]',
    wrapper: '[data-free-gift-wrapper]',
    claim: '[data-free-gift-claim]',
    thresholdText: '[data-free-gift-threshold-text]'
  };

  function dollarsFromCents(cents) {
    var v = Math.max(0, Number(cents) || 0) / 100;
    return v.toFixed(2);
  }

  async function getCart() {
    var res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch /cart.js');
    return await res.json();
  }

  function getConfig() {
    var wrap = document.querySelector(SEL.wrapper);
    if (!wrap) return null;

    return {
      wrap: wrap,
      variantId: Number(wrap.getAttribute('data-free-gift-variant-id')) || 0,
      thresholdCents: Number(wrap.getAttribute('data-free-gift-threshold-cents')) || 0,
      message: wrap.getAttribute('data-free-gift-message') || ''
    };
  }

  function giftInCartAtZero(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (Number(it.variant_id) === Number(variantId)) {
        return Number(it.final_line_price) === 0;
      }
    }
    return false;
  }

  function eligibleSubtotalCents(cart, variantId) {
    var subtotal = Number(cart.items_subtotal_price) || 0;

    // subtract gift line if present so it doesn't help qualify
    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (it) {
        if (Number(it.variant_id) === Number(variantId)) {
          subtotal -= Number(it.final_line_price) || 0;
        }
      });
    }
    return Math.max(0, subtotal);
  }

  function updateUI(config, cart) {
    if (!config || !config.wrap) return;

    // If gift is already in cart at $0, remove promo block entirely
    if (giftInCartAtZero(cart, config.variantId)) {
      var mount = config.wrap.closest(SEL.mount);
      if (mount) mount.innerHTML = ''; // keep mount, clear content
      else config.wrap.remove();
      return;
    }

    var eligible = eligibleSubtotalCents(cart, config.variantId);
    var remaining = config.thresholdCents - eligible;
    var unlocked = remaining <= 0;

    var txt = config.wrap.querySelector(SEL.thresholdText);
    if (txt) {
      txt.textContent = unlocked
        ? 'Free Gift Ready To Claim'
        : ((remaining/100).toLocaleString('en-US', { style:'currency', currency:'USD' }) + ' away to unlock!');
    }

    var btn = config.wrap.querySelector(SEL.claim);
    if (btn) {
      if (unlocked) {
        btn.disabled = false;
        btn.setAttribute('aria-disabled', 'false');
      } else {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
    }
  }

  async function refresh() {
    var config = getConfig();
    if (!config) return;

    var cart = await getCart();
    updateUI(config, cart);
  }

async function claim() {
  if (__claiming) return;      // ✅ prevents double add from fast clicks or double events
  __claiming = true;

  const config = getConfig();
  if (!config || !config.variantId) {
    __claiming = false;
    return;
  }

  const btn = config.wrap.querySelector('[data-free-gift-claim]');
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Adding...';
    btn.setAttribute('aria-disabled', 'true');
  }

  try {
    const payload = {
      items: [{
        id: config.variantId,
        quantity: 1,
        properties: {
          _free_gift: 'true',
          _free_gift_message: config.message || ''
        }
      }]
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error('Add failed: ' + res.status);

    // ✅ Immediately hide promo (don’t wait for cart refresh)
    const mount = config.wrap.closest('[data-free-gift-mount]');
    if (mount) mount.innerHTML = '';

    // ✅ Refresh cart UI
    if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
      window.PXUTheme.jsAjaxCart.updateView();
    } else if (window.zCartPromo && typeof window.zCartPromo.refresh === 'function') {
      window.zCartPromo.refresh().catch(() => {});
    }

  } catch (e) {
    console.error('[zCartPromo] claim error', e);
    if (btn) {
      btn.textContent = 'Claim';
      btn.disabled = false;
      btn.setAttribute('aria-disabled', 'false');
    }
  } finally {
    __claiming = false;
  }
}

  function bind() {
    if (__bound) return;        // ✅ prevents duplicate bindings
    __bound = true;

    document.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest && e.target.closest('[data-free-gift-claim]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      window.zCartPromo.claim();
    }, true); // ✅ capture phase helps if theme stops bubbling
  }

  function init() {
    bind();
    refresh().catch(function () {});
  }

  window.zCartPromo = {
    init: init,
    refresh: refresh,
    claim: claim
  };
})();


// auto-init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    window.zCartPromo?.init?.();
  });
} else {
  window.zCartPromo?.init?.();
}